import moment from 'moment-timezone';
import { DataSyncJob, DataSyncRequest, DataSyncScope, DataSyncStatus } from 'src/components/star-grid/starGridTypes';

export const ACTIVE_SYNC_STATUSES: ReadonlySet<DataSyncStatus> = new Set(['STARTING', 'RUNNING']);

export interface DataSyncForm {
  readonly scope: DataSyncScope;
  readonly scenario: string;
  readonly fromMonth: string;
  readonly toMonth: string;
}

export type SyncValidationError = 'invalidScenario' | 'invalidMonth' | 'invalidRange';

export function validateSyncForm(form: DataSyncForm): SyncValidationError | undefined {
  if (form.scope === 'FULL') return undefined;
  if (!/^\d+$/.test(form.scenario.trim()) || !Number.isSafeInteger(Number(form.scenario))) return 'invalidScenario';
  for (const value of [form.fromMonth, form.toMonth]) {
    if (!/^[1-9]\d{3}(0[1-9]|1[0-2])$/.test(value.trim())) return 'invalidMonth';
  }
  return Number(form.fromMonth) > Number(form.toMonth) ? 'invalidRange' : undefined;
}

export function syncRequest(form: DataSyncForm): DataSyncRequest {
  if (form.scope === 'FULL') return { sync_scope: 'FULL' };
  return {
    sync_scope: 'RANGE',
    reporting_scenario_id: Number(form.scenario),
    from_month_id: Number(form.fromMonth),
    to_month_id: Number(form.toMonth)
  };
}

export function syncElapsedMs(job: DataSyncJob, now: number): number | undefined {
  if (job.total_ms != null) return job.total_ms;
  if (!job.started_at) return undefined;
  const started = moment(job.started_at);
  const end = job.finished_at ? moment(job.finished_at).valueOf() : now;
  if (!started.isValid() || !Number.isFinite(end)) return undefined;
  if (!ACTIVE_SYNC_STATUSES.has(job.status) && !job.finished_at) return undefined;
  return Math.max(0, end - started.valueOf());
}

export function syncMonthRange(job: DataSyncJob): string | undefined {
  if (job.from_month_id == null || job.to_month_id == null) return undefined;
  const from = moment(String(job.from_month_id), 'YYYYMM', true);
  const to = moment(String(job.to_month_id), 'YYYYMM', true);
  if (!from.isValid() || !to.isValid()) return undefined;
  return `${from.format('MMM YYYY')} – ${to.format('MMM YYYY')}`;
}
